import { Link } from "react-router-dom";
import { useState } from "react";
import { useLanguage } from "@/i18n/LanguageContext";

interface PinecrestHeroProps {
  h1?: string;
  subhead?: string;
  zips?: string[];
}

export default function PinecrestHero({ h1, subhead, zips }: PinecrestHeroProps) {
  const [imgFailed, setImgFailed] = useState(false);
  const { t, currentLang } = useLanguage();

  return (
    <section className="relative py-24 md:py-32 overflow-hidden min-h-[70vh] flex items-center justify-center">
      {!imgFailed && (
        <img
          src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/bd2499d8-debf-4747-a18e-6d4b3ae9f63e_Sliding-Door-Repair-Miami-2.png?v=a0c53dd0158734361bfa1e21308c8560"
          alt={currentLang === "es" ? "Reparación de ventanas en Pinecrest Miami" : "Window repair in Pinecrest Miami"}
          className="absolute inset-0 w-full h-full object-cover"
          onError={() => setImgFailed(true)}
        />
      )}
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative z-10 max-w-4xl mx-auto px-8 text-center">
        <div className="max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-white/70 mb-8 font-sans">
            {currentLang === "es" ? "Reparación de Ventanas Pinecrest" : "PINECREST WINDOW REPAIR"}
          </p>
          <h1 className="font-serif font-light italic text-4xl md:text-5xl lg:text-6xl text-white mb-8 leading-tight">
            {h1 || t("pinecrest.h1")}
          </h1>
          <p className="max-w-lg mx-auto text-white/80 italic text-base leading-relaxed mb-12 font-sans">
            {subhead || t("pinecrest.subhead")}
          </p>
          {zips && zips.length > 0 && (
            <p className="text-xs text-white/60 mb-8 font-sans">
              {t("hood.zipCodes")}{zips.join(", ")}
            </p>
          )}
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-[#ea580c] text-white px-8 py-4 text-sm font-bold rounded-md hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("hood.callNow")}
          </a>
        </div>
      </div>
    </section>
  );
}